import type { BroadcastTemplate } from "../../api/admin-communications";
import { t } from "../../i18n";

export const BROADCAST_TEMPLATES: ReadonlyArray<BroadcastTemplate> = [
  "service_degraded_warning",
  "maintenance_window",
  "incident_alert",
  "incident_resolved",
  "privacy_policy_changed",
  "terms_changed",
  "data_breach_notification",
];

export function templateLabel(template: BroadcastTemplate): string {
  return t(`communications.template.${template}`);
}

export function formatDate(value: string | null): string {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export function progressText(progress: {
  readonly target_count: number;
  readonly enqueued_count: number;
  readonly failed_count: number;
}): string {
  return `${progress.enqueued_count}/${progress.target_count} (${progress.failed_count})`;
}

export function shortId(id: string): string {
  return id.length <= 10 ? id : id.slice(0, 10);
}
